import React from 'react';
import { Button } from '@mui/material';

const LoaderButton = ({
  isLoading,
  text,
  loadingText,
  disabled = false,
  ...props
}) => (
  <Button
    variant="contained"
    color="secondary"
    disabled={disabled || isLoading}
    sx={{ paddingY: 1 }}
    {...props}
  >
    {!isLoading ? text : loadingText}
  </Button>
);

export default LoaderButton;
